import { fetchChecklistConfig, getQuestionLocationMap, getQuestionMap } from "../../services/checklistService";
import { setConfig, setError, setLoading } from "../slices/checklistSlice";
import { AppThunk } from "../store";

export const fetchChecklist = (checklistType: string, version: string = "latest"): AppThunk => async (dispatch) => {
    dispatch(setLoading(true));
    dispatch(setError(null));

    try {
        const config = await fetchChecklistConfig(checklistType, version);
        const questionMap = getQuestionMap(checklistType, version) || {};
        const questionLocationMap = getQuestionLocationMap(checklistType, version) || {};

        dispatch(setConfig({ config, questionMap, questionLocationMap }));
    } catch (error) {
        console.error("Failed to fetch checklist:", error);
        dispatch(setError(`Failed to load checklist configuration for ${checklistType}`));
    } finally {
        dispatch(setLoading(false));
    }
};
